import { makeAutoObservable } from "mobx";
import { translate, t } from "../I18n";
export class CreatorConfigValidation {
    constructor(params) {
        this._state = "default";
        this.hasError = params.hasError;
        this.minItems = params.minItems;
        this.maxItems = params.maxItems;
        makeAutoObservable(this);
    }
    validate() {
        if (this.hasError()) {
            this._state = "error";
            return;
        }
        switch (this._state) {
            case "default":
                this._state = "default";
                break;
            case "error":
                this._state = "success";
                break;
            case "success":
                this._state = "success";
                break;
        }
    }
    get isRequired() {
        return !this.minItems.isZero;
    }
    get state() {
        return this._state;
    }
    // Validation text is not based on availability because we want to show
    // user friendly messages even in the valid state (e.g., "Choose max 3 items"
    // for the NOT required element)
    get validationText() {
        if (this.maxItems !== null &&
            this.maxItems.value > 0 &&
            this.minItems.eq(this.maxItems)) {
            return translate(t._core_types_sites.menu.creator.errors.chooseExactlyNModifierItems, { expectedItems: this.maxItems.value.toString() });
        }
        if (this.maxItems !== null && this.maxItems.value > 0) {
            return translate(t._core_types_sites.menu.creator.errors.chooseAtMostNModifierItems, { maxItems: this.maxItems.value.toString() });
        }
        if (this.minItems.value > 0) {
            return translate(t._core_types_sites.menu.creator.errors.chooseAtLeastNModifierItems, { minItems: this.minItems.value.toString() });
        }
        return null;
    }
}
